import styled, { css } from 'styled-components';

import { mediaDesktop } from 'utils/styles/responsive';

export const Image = styled.img`
  grid-column: 2 / -2;

  margin-bottom: 120px;
  width: 100%;

  ${mediaDesktop(css`
    margin-bottom: 200px;
  `)}
`;
